import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["format", "valueSet", "multiSelectLimit"];
  }

  connect() {
    this.configureFields();
  }

  configureFields() {
    if (this.valueSetTarget.value.length === 0) {
      this.formatTarget.closest(".format-input-field").classList.remove("dn");

      this.multiSelectLimitTarget.selectedIndex = 0;

      const trigger = this.multiSelectLimitTarget
        .closest(".multi_select_limit-input-field")
        .querySelector(".dropdown-trigger");

      if (trigger) {
        trigger.click();
      }
      this.multiSelectLimitTarget.closest(".multi_select_limit-input-field").classList.add("dn");
    } else {
      this.formatTarget.closest(".format-input-field").classList.add("dn");

      this.multiSelectLimitTarget.closest(".multi_select_limit-input-field").classList.remove("dn");
    }
  }
}


